// material-ui
import { DataGrid } from '../../../components/grid/DataGrid';

// project import
import MainLayout from '../../../layout/MainLayout';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState } from 'react';
import MainCard from '../../../components/MainCard';
import {
  DeleteOutlined,
  EditOutlined,
  SettingOutlined,
  OrderedListOutlined
} from '@ant-design/icons';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton
} from '@mui/x-data-grid-pro';

import { Button, Box } from '@mui/material';

import {
  actions as routeActions,
  types as routes
} from 'reducers/rotas.actions';

import * as actions from 'reducers/produtosOperacoes.reducer';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import useTheme from '@mui/system/useTheme';
import { toast } from 'react-toastify';
import { funcaoFiltro } from 'utils/funcaoFiltro';
import { opcoesFiltro } from 'utils/opcoesFiltro';

const ProdutosPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const produtos = useSelector((state) => state.produtos.produtos.data);
  const loading = useSelector((state) => state.produtos.produtos.loading);

  const rows = produtos;

  const columns = [
    {
      field: 'nomeOperacao',
      headerName: 'Nome',
      flex: 1
    },
    {
      field: 'tipoSituacao',
      headerName: 'Situação',
      flex: 1,
      valueFormatter: (value) => {
        return value === 'A' ? 'Ativo' : value === 'I' ? 'Inativo' : '';
      },
      filterOperators: [
        {
          label: 'igual à',
          value: 'is',
          getApplyFilterFn: (filterItem) => funcaoFiltro(filterItem),
          InputComponent: (props) =>
            opcoesFiltro(props, [
              { codigo: 'A', nome: 'Ativo' },
              { codigo: 'I', nome: 'Inativo' }
            ])
        }
      ]
    }
  ];

  const [open, setOpen] = useState(false);

  const handleClickOpen = (row) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNewProduto = () => {
    dispatch(
      routeActions.redirectTo(routes.PRODUTO, {
        idOperacao: 'novo'
      })
    );
  };

  const CustomToolbar = ({ apiRef }) => {
    const selectedRows = apiRef.current.getSelectedRows();
    const selectedRowData = Array.from(selectedRows.values());

    const handleDeleteClick = () => {
      dispatch(actions.excluirProdutoRequest({ value: selectedRowData[0] }));
      setOpen(false);
    };

    const handleEdit = () => {
      if (selectedRows.size === 0) {
        toast.error('Selecione pelo menos uma linha.');
      } else {
        dispatch(
          routeActions.redirectTo(routes.PRODUTO, {
            idOperacao: selectedRowData[0].idOperacao
          })
        );
      }
    };

    const handleClickEtapas = () => {
      dispatch(
        routeActions.redirectTo(routes.PRODUTO_ETAPAS, {
          idOperacao: selectedRowData[0].idOperacao
        })
      );
    };

    return (
      <>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Confirmação para Exclusão de Operação</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Tem certeza de que deseja excluir a Operação{' '}
              {selectedRowData[0]?.nomeOperacao}? Ao excluir uma operação, não
              será mais possível recuperar suas informações.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handleDeleteClick} color="error">
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport
            csvOptions={{ includeHeaders: true, allColumns: true }}
          />
          <Button
            variant="text"
            color="primary"
            onClick={handleNewProduto}
            startIcon={<SettingOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Incluir Operação
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={selectedRows.size !== 1}
            onClick={handleEdit}
            startIcon={<EditOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Editar
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={
              selectedRows.size !== 1 ||
              selectedRowData[0]?.tipoSituacao !== 'A'
            }
            onClick={handleClickOpen}
            startIcon={<DeleteOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px',
              color: `${
                selectedRows.size !== 1 ||
                selectedRowData[0]?.tipoSituacao !== 'A'
                  ? theme.palette.grey.lighter
                  : theme.palette.error.main
              } !important`
            }}
          >
            Excluir
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={selectedRows.size !== 1}
            onClick={handleClickEtapas}
            startIcon={<OrderedListOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Etapas
          </Button>
        </GridToolbarContainer>
      </>
    );
  };

  return (
    <MainLayout>
      <MainCard
        title="Configuração de Operações"
        border={false}
        sx={{ paddingBottom: '0px' }}
      >
        <Box sx={{ marginTop: '5px' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSizeOptions={[10]}
            getRowId={(row) => row.idOperacao}
            toolbar={CustomToolbar}
            loading={loading}
            pageSize={10}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10
                }
              },
              density: 'standard'
            }}
            noLineText="Nenhuma operação encontrada"
          />
        </Box>
      </MainCard>
    </MainLayout>
  );
};

export default ProdutosPage;
